
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { useLocation, useNavigate } from "react-router-dom";

const UserChannels = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isTreyProfile = location.pathname === "/trey-profile";
  const isJuliaProfile = location.pathname === "/julia-derosi-profile";
  const isHeatherProfile = location.pathname === "/heather-edwards-profile";
  const isCharlesProfile = location.pathname === "/charles-hardy-profile";

  const juliaNetworkMembers = [
    {
      name: "Heather Edwards",
      image: "/lovable-uploads/73b456ea-9c98-40f6-bfc3-64fa80dc59b8.png",
      route: "/heather-edwards-profile"
    },
    {
      name: "Charles Hardy",
      image: "/lovable-uploads/91e1d8d9-e9d2-40b6-b0a9-ce85c915f266.png",
      route: "/charles-hardy-profile"
    },
    {
      name: "Pete Dumont",
      image: "/lovable-uploads/75f9c580-ff6c-4545-9839-76314bebae9f.png",
      route: "/pete-profile"
    },
    {
      name: "Trey Fleming",
      image: "/lovable-uploads/645369ee-7ed8-4496-a783-9195e483aded.png",
      route: "/trey-profile"
    },
    {
      name: "Karen Watson",
      image: "/lovable-uploads/e98049ee-495a-4700-9f03-d39e22e3a116.png",
      route: "/karen-profile"
    }
  ];

  const charlesNetworkMembers = [
    {
      name: "Julia De Rosi",
      image: "/lovable-uploads/9b5669bd-2272-447b-bb9d-71b0c8f710c6.png",
      route: "/julia-derosi-profile"
    },
    {
      name: "Heather Edwards",
      image: "/lovable-uploads/73b456ea-9c98-40f6-bfc3-64fa80dc59b8.png",
      route: "/heather-edwards-profile"
    },
    {
      name: "Pete Dumont",
      image: "/lovable-uploads/75f9c580-ff6c-4545-9839-76314bebae9f.png",
      route: "/pete-profile"
    },
    {
      name: "Trey Fleming",
      image: "/lovable-uploads/645369ee-7ed8-4496-a783-9195e483aded.png",
      route: "/trey-profile"
    },
    {
      name: "Karen Watson",
      image: "/lovable-uploads/e98049ee-495a-4700-9f03-d39e22e3a116.png",
      route: "/karen-profile"
    }
  ];

  const heatherNetworkMembers = [
    {
      name: "Julia De Rosi",
      image: "/lovable-uploads/9b5669bd-2272-447b-bb9d-71b0c8f710c6.png",
      route: "/julia-derosi-profile"
    },
    {
      name: "Charles Hardy",
      image: "/lovable-uploads/91e1d8d9-e9d2-40b6-b0a9-ce85c915f266.png",
      route: "/charles-hardy-profile"
    },
    {
      name: "Pete Dumont",
      image: "/lovable-uploads/75f9c580-ff6c-4545-9839-76314bebae9f.png",
      route: "/pete-profile"
    },
    {
      name: "Trey Fleming",
      image: "/lovable-uploads/645369ee-7ed8-4496-a783-9195e483aded.png",
      route: "/trey-profile"
    },
    {
      name: "Karen Watson",
      image: "/lovable-uploads/e98049ee-495a-4700-9f03-d39e22e3a116.png",
      route: "/karen-profile"
    }
  ];

  return (
    <div className="flex justify-center gap-2">
      <HoverCard>
        <HoverCardTrigger asChild>
          <Button 
            variant="outline" 
            size="sm"
            className="bg-white text-black hover:bg-gray-100"
          >
            BIO
          </Button>
        </HoverCardTrigger>
        <HoverCardContent className="w-96">
          {isTreyProfile ? (
            <div className="space-y-2">
              <h4 className="text-lg font-semibold">Trey Fleming</h4>
              <p className="text-sm text-gray-600">
                Trey Fleming founded iSPAI in 2024 and is the architect behind the company vision. He has nearly 30 years of experience working in technology consulting, systems integration, outsourcing, research, and advisory services.
              </p>
              <p className="text-sm text-gray-600">
                He's worked with a variety of companies throughout his career with an industry focus on Oil and Gas, Energy, and Utilities. Most recently Trey was the Chief Revenue Officer for a 40-year-old information management company based in Houston, Texas.
              </p>
              <p className="text-sm text-gray-600">
                Trey is a certified expert in NFTs (via the Blockchain Council) and began his career in politics and government. He has worked for a US Presidential candidate, a US Senator, a Texas Governor, and a US Congressional candidate, as well as running for the Texas House of Representatives in 2008. Trey splits time between Texas and Colorado.
              </p>
              <h4 className="text-md font-semibold mt-3">Experience</h4>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Founder</p>
                <p>iSPAI · 2022 - Present</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Chief Revenue Officer</p>
                <p>Information Management Company · 2019 - 2022</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Technology Consultant</p>
                <p>Various Industries · 2010 - 2019</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Political Career</p>
                <p>Government & Politics · 2000 - 2008</p>
              </div>
            </div>
          ) : isJuliaProfile ? (
            <div className="space-y-2">
              <h4 className="text-lg font-semibold">Julia De Rosi</h4>
              <p className="text-sm text-gray-600">
                Julia De Rosi serves as the Deputy Assistant Commissioner of the Public Buildings Service at the General Services Administration (GSA). 
                She leads the largest federal real estate agency, responsible for construction and maintenance of a 370 million square feet 
                portfolio nationwide.
              </p>
              <p className="text-sm text-gray-600">
                Julia leads a high performing team of 7 Directors and 254 project managers responsible for the successful delivery of a $21B project portfolio.
                She has 25 years of experience in leadership, public real estate investment strategy, execution, and operations.
              </p>
              <h4 className="text-md font-semibold mt-3">Experience</h4>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Deputy Assistant Commissioner</p>
                <p>GSA · May 2020 - Present</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Zone Director | Office of Design and Construction</p>
                <p>GSA · Mar 2019 - May 2020</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Program Manager</p>
                <p>GSA · Sep 2014 - Mar 2019</p>
              </div>
              <div className="text-sm text-gray-600">
                <p className="font-medium">Board Of Directors</p>
                <p>Illinois Green Alliance · Jan 2018 - Jan 2020</p>
              </div>
            </div>
          ) : isHeatherProfile ? (
            <div className="space-y-2">
              <h4 className="text-lg font-semibold">Heather Edwards</h4>
              <p className="text-sm text-gray-600">
                Strategic and results-driven leader with a track record of guiding award-winning teams, driving high-impact initiatives, 
                and delivering premier organizational projects. Rooted in extensive experience in workplace strategy, I lead with a 
                people-first mindset—fostering collaboration, adaptability, and innovation to enhance team performance and organizational success.
              </p>
              <p className="text-sm text-gray-600">
                Seamlessly integrating my background in graphic and visual communication expertise to elevate how teams engage, collaborate, 
                and deliver results sets my leadership style apart. With a keen eye for design and storytelling, I translate complex ideas 
                into compelling, accessible narratives—enhancing strategic alignment and impact.
              </p>
              <p className="text-sm text-gray-600">
                Passionate about developing high-performing teams, optimizing processes, and cultivating a culture of continuous learning. 
                Skilled at translating complex concepts into pragmatic, incremental steps that drive measurable outcomes.
              </p>
              <p className="text-sm text-gray-600">
                With a unique portfolio spanning workplace strategy, project management, architectural services, facilities management, 
                and owners' representation, I take a holistic approach to leadership—aligning people, processes, and environments to 
                maximize impact and efficiency.
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              <h4 className="text-lg font-semibold">Team Member</h4>
              <p className="text-sm text-gray-600">
                mySPAI team member biography information will be displayed here.
              </p>
            </div>
          )}
        </HoverCardContent>
      </HoverCard>
      {isJuliaProfile ? (
        <HoverCard>
          <HoverCardTrigger asChild>
            <Button 
              variant="outline" 
              size="sm"
              className="bg-white text-black hover:bg-gray-100"
            >
              NW
            </Button>
          </HoverCardTrigger>
          <HoverCardContent className="w-80">
            <div className="space-y-3">
              <h4 className="text-lg font-semibold text-center">Julia's Network</h4>
              <div className="grid grid-cols-3 gap-4">
                {juliaNetworkMembers.map((member) => (
                  <div
                    key={member.name}
                    className="flex flex-col items-center cursor-pointer transition-transform hover:scale-110"
                    onClick={() => navigate(member.route)}
                  >
                    <div
                      className="w-16 h-16 rounded-lg bg-cover bg-center border-2 border-gray-200 hover:border-primary"
                      style={{ backgroundImage: `url(${member.image})` }}
                    />
                    <span className="text-xs mt-1 text-center">{member.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>
      ) : isCharlesProfile ? (
        <HoverCard>
          <HoverCardTrigger asChild>
            <Button 
              variant="outline" 
              size="sm"
              className="bg-white text-black hover:bg-gray-100"
            >
              NW
            </Button>
          </HoverCardTrigger>
          <HoverCardContent className="w-80">
            <div className="space-y-3">
              <h4 className="text-lg font-semibold text-center">Charles' Network</h4>
              <div className="grid grid-cols-3 gap-4">
                {charlesNetworkMembers.map((member) => (
                  <div
                    key={member.name}
                    className="flex flex-col items-center cursor-pointer transition-transform hover:scale-110"
                    onClick={() => navigate(member.route)}
                  >
                    <div
                      className="w-16 h-16 rounded-lg bg-cover bg-center border-2 border-gray-200 hover:border-primary"
                      style={{ backgroundImage: `url(${member.image})` }}
                    />
                    <span className="text-xs mt-1 text-center">{member.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>
      ) : isHeatherProfile ? (
        <HoverCard>
          <HoverCardTrigger asChild>
            <Button 
              variant="outline" 
              size="sm"
              className="bg-white text-black hover:bg-gray-100"
            >
              NW
            </Button>
          </HoverCardTrigger>
          <HoverCardContent className="w-80">
            <div className="space-y-3">
              <h4 className="text-lg font-semibold text-center">Heather's Network</h4>
              <div className="grid grid-cols-3 gap-4">
                {heatherNetworkMembers.map((member) => (
                  <div
                    key={member.name}
                    className="flex flex-col items-center cursor-pointer transition-transform hover:scale-110"
                    onClick={() => navigate(member.route)}
                  >
                    <div
                      className="w-16 h-16 rounded-lg bg-cover bg-center border-2 border-gray-200 hover:border-primary"
                      style={{ backgroundImage: `url(${member.image})` }}
                    />
                    <span className="text-xs mt-1 text-center">{member.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>
      ) : (
        <Button 
          variant="outline" 
          size="sm"
          className="bg-white text-black hover:bg-gray-100"
        >
          NW
        </Button>
      )}
    </div>
  );
};

export default UserChannels;
